"use strict";
// ===========================================================================
// DO NOT EDIT THIS FILE MANUALLY!
//
// The contents have been added automatically.
// See: scripts/generate-dapps.ts for more information
// ===========================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAPPS = void 0;
exports.DAPPS = [
    { aliases: { apebank: { chains: ['apechain'], title: 'ApeBank' } }, homepageUrl: 'https://ape-bank.netlify.app/' },
    {
        aliases: {
            'compound-finance-usde': {
                chains: ['mantle'],
                title: 'Compound Finance USDe market',
                description: 'Only to be used for the USDe market.',
            },
        },
        homepageUrl: 'https://compound.finance/',
    },
    { aliases: { dtrinity: { chains: ['fraxtal', 'sonic'], title: 'dTRINITY' } }, homepageUrl: 'https://dtrinity.org/' },
    { aliases: { enclabs: { chains: ['sonic'], title: 'Enclabs' } }, homepageUrl: 'https://www.enclabs.finance/' },
    { aliases: { hana: { chains: ['taiko'], title: 'Hana Finance' } }, homepageUrl: 'https://www.hana.finance/' },
    { aliases: { init: { chains: ['blast', 'mantle'], title: 'INIT Capital' } }, homepageUrl: 'https://init.capital/' },
    { aliases: { lendle: { chains: ['mantle'], title: 'Lendle' } }, homepageUrl: 'https://www.lendle.xyz/' },
    { aliases: { 'mach-finance': { chains: ['sonic'], title: 'MachFi' } }, homepageUrl: 'https://www.machfi.xyz/' },
    { aliases: { malda: { chains: ['linea'], title: 'Malda' } }, homepageUrl: 'https://malda.xyz/' },
    { aliases: { moonwell: { chains: ['moonbeam'], title: 'Moonwell' } }, homepageUrl: 'https://moonwell.fi/' },
    {
        aliases: {
            'morpho-mvl-usdc-770-lltv': {
                chains: ['ethereum'],
                title: 'Morpho MVL/USDC 77% LLTV',
                description: 'Only to be used for the MVL/USDC 77% LLTV market.',
            },
            'morpho-wsteth-usdc-860-lltv': {
                chains: ['ethereum', 'gnosis'],
                title: 'Morpho wstETH/USDC 86% LLTV',
                description: 'Only to be used for the wstETH/USDC 86% LLTV market.',
            },
            'morpho-wbtc-usdc-860-lltv': {
                chains: ['ethereum'],
                title: 'Morpho WBTC/USDC 86% LLTV',
                description: 'Only to be used for the WBTC/USDC 86% LLTV market.',
            },
            'morpho-cbbtc-usdc-860-lltv': {
                chains: ['ethereum'],
                title: 'Morpho cbBTC/USDC 86% LLTV',
                description: 'Only to be used for the cbBTC/USDC 86% LLTV market.',
            },
            'morpho-vbeth-vbusdc-860-lltv': {
                chains: ['katana'],
                title: 'Morpho vbETH/vbUSDC 86% LLTV',
                description: 'Only to be used for the vbETH/vbUSDC 86% LLTV market.',
            },
            'morpho-vbeth-vbusdt-860-lltv': {
                chains: ['katana'],
                title: 'Morpho vbETH/vbUSDT 86% LLTV',
                description: 'Only to be used for the vbETH/vbUSDT 86% LLTV market.',
            },
            'morpho-vbwbtc-vbusdc-860-lltv': {
                chains: ['katana'],
                title: 'Morpho vbWBTC/vbUSDC 86% LLTV',
                description: 'Only to be used for the vbWBTC/vbUSDC 86% LLTV market.',
            },
            'morpho-vbwbtc-vbusdt-860-lltv': {
                chains: ['katana'],
                title: 'Morpho vbWBTC/vbUSDT 86% LLTV',
                description: 'Only to be used for the vbWBTC/vbUSDT 86% LLTV market.',
            },
            'morpho-gno-usdc-860-lltv': {
                chains: ['gnosis'],
                title: 'Morpho GNO/USDC 86% LLTV',
                description: 'Only to be used for the GNO/USDC 86% LLTV market.',
            },
            'morpho-sdai-usdc-860-lltv': {
                chains: ['gnosis'],
                title: 'Morpho sDAI/USDC 86% LLTV',
                description: 'Only to be used for the sDAI/USDC 86% LLTV market.',
            },
        },
        homepageUrl: 'https://morpho.org/vaults/',
    },
    { aliases: { nerite: { chains: ['arbitrum'], title: 'Nerite' } }, homepageUrl: 'https://www.nerite.org/' },
    { aliases: { orbit: { chains: ['blast'], title: 'Orbit Protocol' } }, homepageUrl: 'https://orbitlending.io/' },
    {
        aliases: { 'segment-finance': { chains: ['bob', 'core'], title: 'Segment Finance' } },
        homepageUrl: 'https://www.segment.finance/',
    },
    {
        aliases: {
            'silo-finance-v1-rdnt': {
                chains: ['arbitrum'],
                title: 'Silo Finance RDNT market',
                description: 'Only to be used for the RDNT market.',
            },
        },
        homepageUrl: 'https://app.silo.finance/',
    },
    { aliases: { stability: { chains: ['sonic'], title: 'Stability' } }, homepageUrl: 'https://stability.farm/' },
    { aliases: { stout: { chains: ['sonic'], title: 'Stout' } }, homepageUrl: 'https://stout.fi/' },
    { aliases: { takara: { chains: ['sei'], title: 'Takara Lend' } }, homepageUrl: 'https://takaralend.com/' },
    {
        aliases: {
            takotako: { chains: ['taiko'], title: 'TakoTako', description: 'Only to be used for the main markets.' },
            'takotako-weeth-eth': {
                chains: ['taiko'],
                title: 'TakoTako weETH/ETH isolated market',
                description: 'Only to be used for the weETH/ETH isolated market.',
            },
        },
        homepageUrl: 'https://www.takotako.xyz/',
    },
    { aliases: { tunnl: { chains: ['polygon'], title: 'tunnl' } }, homepageUrl: 'https://www.tunnl.exchange/' },
    { aliases: { yei: { chains: ['sei'], title: 'Yei Finance' } }, homepageUrl: 'https://www.yei.finance/' },
    { aliases: { zerolend: { chains: ['zircuit'], title: 'ZeroLend' } }, homepageUrl: 'https://zerolend.xyz/' },
];
//# sourceMappingURL=dapps.js.map